import * as React from 'react';
import * as ReactDOM from 'react-dom';
import FocusLock from 'react-focus-lock';
import { useEventListener } from '@kvika/hooks';
import Overlay from './Overlay';
import ModalContext from './ModalContext';
import { Animation } from './Animation';
import { ModalSize } from './Constants';
import { StyledModal } from './styles/ModalStyles';
var Modal = function (_a) {
    var _b = _a.isVisible, isVisible = _b === void 0 ? false : _b, children = _a.children, _c = _a.size, size = _c === void 0 ? ModalSize.MEDIUM : _c, className = _a.className, _d = _a.autoFocus, autoFocus = _d === void 0 ? true : _d, _e = _a.testId, testId = _e === void 0 ? 'kvika-modal' : _e, _f = _a.closeOnClickOutside, closeOnClickOutside = _f === void 0 ? true : _f, onClose = _a.onClose, _g = _a.onExitAnimationEnd, onExitAnimationEnd = _g === void 0 ? function () { return undefined; } : _g;
    var modalRef = React.useRef(null);
    var onKeyDown = function (event) {
        if (event.key === 'Escape' && onClose) {
            onClose();
        }
    };
    var onMouseDown = function (event) {
        if (modalRef &&
            modalRef.current &&
            !modalRef.current.contains(event.target) &&
            onClose &&
            closeOnClickOutside) {
            onClose();
        }
    };
    useEventListener({ type: 'keydown', listener: onKeyDown });
    useEventListener({ type: 'mousedown', listener: onMouseDown });
    var context = { onClose: onClose, testId: testId };
    var Component = (React.createElement(ModalContext.Provider, { value: context },
        React.createElement(Animation, { ref: modalRef, isVisible: isVisible, onExitAnimationEnd: onExitAnimationEnd }, function (style) {
            return (React.createElement(Overlay, { styles: style, testId: testId },
                React.createElement(FocusLock, { className: "kvika-focus-lock", returnFocus: true, autoFocus: autoFocus },
                    React.createElement(StyledModal, { "aria-hidden": "false", "aria-modal": "true", role: "dialog", ref: modalRef, className: className, "data-testid": testId, style: style, size: size }, children))));
        })));
    return ReactDOM.createPortal(Component, document.body);
};
export default Modal;
//# sourceMappingURL=Modal.js.map